import { makeStyles } from "tss-react/mui"
import { Grid, Typography } from "@mui/material"
import { Player } from "@lottiefiles/react-lottie-player"
import lottieAnim from "../assets/maintenance-animation.json"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({}))
export function MaintenanceContent() {
    const { classes } = useStyles()

    return (
        <Grid container alignItems="center" gap={3} flexDirection="column">
            <LocalizedStrict id="page-header-help-maintenance">
                <Typography variant="h5" textAlign="center">
                    Sorry, the page is currently unavailable as it is undergoing maintenance.
                </Typography>
            </LocalizedStrict>
            <Grid container justifyContent={"center"}>
                <Player src={lottieAnim} autoplay loop controls={false} style={{ width: "70%" }} />
            </Grid>
        </Grid>
    )
}
